module.exports = __webpack_public_path__ + "img/globe.cdab510e.png";